@if (state$ | async; as state) {
  @if (selectedTeam(); as selectedTeam) {
    <div style="padding: 1rem">
      @switch (state) {
        @case (NotificationBarState.MaxBranchesPerWorkspaceExceeded) {
          <span>
            Your team has exceeded the maximum number of branches in this
            workspace.
          </span>
          <dt-upgrade-link [team]="selectedTeam"></dt-upgrade-link>
        }
        @case (NotificationBarState.MaxWorkspacesPerTeamExceeded) {
          <span>
            Your team has exceeded the maximum number of workspaces.
          </span>
          <dt-upgrade-link [team]="selectedTeam"></dt-upgrade-link>
        }
        @case (NotificationBarState.MaxTeamMembersExceeded) {
          <span>
            Your team has exceeded the maximum number of team members.
          </span>
          <dt-upgrade-link [team]="selectedTeam"></dt-upgrade-link>
        }
        @case (NotificationBarState.MaxThemesPerWorkspaceExceeded) {
          <span>
            Your team has exceeded the maximum number of themes in this
            workspace.
          </span>
          <dt-upgrade-link [team]="selectedTeam"></dt-upgrade-link>
        }
      }
    </div>
  }
}
